/**
 * Footer column definitions for public marketing pages (internal routes, mailto, or external URLs).
 * Paths under /devs/ and /blog match the future www.quillai.app site structure (placeholders in-app).
 *
 * @typedef {{ label: string, to?: string, href?: string }} MarketingFooterLink
 * @typedef {{ title: string, links: ReadonlyArray<MarketingFooterLink> }} MarketingFooterColumn
 */

/** @type {ReadonlyArray<MarketingFooterColumn>} */
export const MARKETING_FOOTER_COLUMNS = [
  {
    title: "Product",
    links: [
      { label: "Features", to: "/#features" },
      { label: "Pricing", to: "/pricing" },
      { label: "Integrations", to: "/devs/integrations" },
      { label: "Demo", to: "/#product-video" },
    ],
  },
  {
    title: "Company",
    links: [
      { label: "About Us", to: "/about" },
      { label: "Careers", to: "/careers" },
      { label: "Contact", to: "/about#contact" },
    ],
  },
  {
    title: "Resources",
    links: [
      { label: "Blog", to: "/blog" },
      { label: "Documentation", to: "/devs/documentation" },
      { label: "API", to: "/devs/api" },
      { label: "Security", to: "/devs/security" },
      { label: "FAQ", to: "/devs/faq" },
    ],
  },
];

/** @type {ReadonlyArray<MarketingFooterLink>} */
export const MARKETING_FOOTER_LEGAL_LINKS = [
  { label: "Privacy Policy", to: "/devs/privacy-policy" },
  { label: "Terms of Service", to: "/devs/terms-of-service" },
];

/**
 * Social icon targets (update to your official profiles).
 * @type {ReadonlyArray<{ label: string, href: string }>}
 */
export const MARKETING_SOCIAL_LINKS = [
  { label: "LinkedIn", href: "https://www.linkedin.com" },
  { label: "X (Twitter)", href: "https://twitter.com" },
  { label: "Facebook", href: "https://www.facebook.com" },
];
